var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00082 11.2945L13.1793 16.5965C13.6988 17.1325 14.0368 17.138 14.5658 16.5965L15.6048 15.5325C16.1138 15.0115 16.1483 14.6695 15.6048 14.113L10.1223 8.50049L15.6053 2.88799C16.1188 2.36049 16.1288 2.00449 15.6053 1.46799L14.5663 0.404494C14.0273 -0.147506 13.6943 -0.122006 13.1798 0.404494L8.00082 5.70649L2.82232 0.404994C2.30782 -0.121506 1.97482 -0.147006 1.43582 0.404994L0.396825 1.46849C-0.127175 2.00499 -0.117676 2.36099 0.396825 2.88849L5.87932 8.50049L0.396825 14.113C-0.146675 14.6695 -0.117676 15.0115 0.396825 15.5325L1.43532 16.5965C1.95982 17.138 2.29782 17.1325 2.82182 16.5965L8.00082 11.2945Z",
    fill: "#D96464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b0689839.svg";
export { ForwardRef as ReactComponent };